import React, { useEffect, useState } from "react";
import RatingStar from "../../../assets/icons/RatingStar.svg";
import HeaderAccount from "../../../components/HeaderAccount";
import axiosWithAuth from "../../../utils/axiosWithAuth";
import { useTranslation } from "react-i18next";
import { SquareLoader } from "react-spinners";
import { getApiEndpoint } from "../../../utils/apiConfig";
import "./_MyForeman.scss";

const MyForeman = () => {
  const { t } = useTranslation();
  document.title = t("myForeman.0");
  const headerTitle = t("myForeman.0");
  const backwardNavigate = "/account";
  const [repairmen, setRepairmen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchRepairmen = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Create axios instance and make the request
        const api = axiosWithAuth();
        const response = await api.get(getApiEndpoint('repairman'));
        
        console.log("API response data:", response.data);
        
        // Handle different response structures
        if (response.data && response.data.success && Array.isArray(response.data.data)) {
          setRepairmen(response.data.data);
        } else if (Array.isArray(response.data)) {
          setRepairmen(response.data);
        } else {
          setRepairmen([]);
        }
      } catch (error) {
        console.error("Failed to fetch repairmen:", error);
        setError(error.message || t("myForeman.noForeman"));
      } finally {
        setLoading(false);
      }
    };

    fetchRepairmen();
  }, [t]);

  if (loading) {
    return (
      <div className="myforeman-section px-3">
        <HeaderAccount title={headerTitle} backwardNavigate={backwardNavigate} />
        <div className="loader-container d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
          <SquareLoader color="#cda742" size={80} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="myforeman-section px-3">
        <HeaderAccount title={headerTitle} backwardNavigate={backwardNavigate} />
        <div className="middle-section">
          <div className="alert alert-danger text-center my-5">
            <i className="fas fa-exclamation-triangle mb-2"></i>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="myforeman-section px-3">
      <HeaderAccount title={headerTitle} backwardNavigate={backwardNavigate} />
      <div className="middle-section">
        {repairmen && repairmen.length > 0 ? (
          repairmen.map((repairman, index) => {
            // Handle image display
            const getImageSrc = () => {
              if (repairman.image) {
                if (repairman.image.hashBase64) {
                  return `data:image/png;base64,${repairman.image.hashBase64}`;
                } else if (repairman.image.url) {
                  return repairman.image.url;
                }
              }
              return null; // Return null instead of placeholder URL
            };

            const handleImageError = (e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '<div class="image-fallback">👤</div>';
            };

            // Handle technical area name
            const getTechnicalAreaName = () => {
              if (repairman.technicalArea && repairman.technicalArea.name) {
                if (typeof repairman.technicalArea.name === 'object') {
                  return repairman.technicalArea.name.text || 
                         repairman.technicalArea.name.az || 
                         repairman.technicalArea.name.en || 
                         t("myForeman.technicalArea");
                }
                return repairman.technicalArea.name;
              }
              return t("myForeman.technicalArea");
            };

            return (
              <div key={repairman._id || index}>
                <div className="foreman-details-section d-flex gap-3 align-items-center justify-content-center py-3">
                  <div className="left-section">
                    {getImageSrc() ? (
                      <img 
                        src={getImageSrc()} 
                        alt={`${repairman.name || ''} ${repairman.surname || ''}`}
                        className="rounded-circle"
                        onError={handleImageError}
                      />
                    ) : (
                      <div className="image-fallback">👤</div>
                    )}
                  </div>
                  <div className="right-section d-flex align-items-center justify-content-between w-100">
                    <div className="name-user-section d-flex flex-column">
                      <div className="name-section">
                        <h5 className="mb-1">
                          {repairman.name || ""} {repairman.surname || ""}
                        </h5>
                      </div>
                      <div className="user-section d-flex gap-2 align-items-center">
                        <img 
                          src={RatingStar} 
                          alt="star" 
                          onError={(e) => e.target.style.display = 'none'}
                        />
                        <small className="text-muted">
                          {getTechnicalAreaName()}
                        </small>
                      </div>
                      {repairman.rating && (
                        <div className="rating-section d-flex gap-1 align-items-center mt-1">
                          <small className="text-warning">
                            ★ {repairman.rating.toFixed(1)}
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="detail-section me-2">
                      <a 
                        href={`tel:${repairman.phoneNumber || "#"}`} 
                        className="btn btn-outline-primary btn-sm"
                        title={t("myForeman.callForeman")}
                      >
                        <i className="fas fa-phone"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center my-5">
            <div className="mb-3">
              <i className="fas fa-user-hard-hat fa-3x text-muted"></i>
            </div>
            <h5 className="text-muted">{t("myForeman.2")}</h5>
            <p className="text-muted small">
              {t("myForeman.noForeman")}
            </p>
          </div>
        )}
      </div>
      <div className="bottom-section mt-5">
        <button className="global-button w-100 py-3">
          <i className="fas fa-phone me-2"></i>
          {t("myForeman.1")}
        </button>
      </div>
    </div>
  );
};

export default MyForeman;
